import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';
import { startSyncingOrganization, requestUploadFileInChunks, requestUploadFile } from '../../modules/Setup/SetupActions';

class ImportData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      progress: 0,
      status: null,
      error: null,
    };

    this.handleFileChange = this.handleFileChange.bind(this);
  }
  

  handleUploadChunks(selectedFile) {
    const fileSize = selectedFile.size;
    let cursor = 0;
    let chunkSize = 0;
    let token = null;

    const uploadNextChunk = () => {
      const chunk = selectedFile.slice(cursor, Math.min(cursor + chunkSize, fileSize)); // first chunk should alwasy be empty ''
      if (cursor !== null && cursor !== undefined) {
        const formData = new FormData();

        if (token) {
          formData.append('token', token);
        } else {
          formData.append('originalName', selectedFile.name); // for backend
          formData.append('fileSize', fileSize);
        }

        formData.append('file', chunk);
        
        this.props.dispatch(requestUploadFileInChunks(formData))
          .then((data) => {
            ({ chunkSize, cursor, token } = data);
            const temp = `Chunk ${data.chunkNumber} uploaded successfully`;
            const progress = fileSize ? (cursor / fileSize) * 100 : 0;
            this.setState({
              status: temp,
              progress,
            })
            uploadNextChunk();
          })
          .catch((error) => {
            this.setState({
              uploading: false,
              progress: 0,
              status: null,
              error: error?.data?.message || 'Error uploading chunk',
            });
          });
      } else {
        this.setState({ progress: 100, status: 'File upload completed' }, () => {
          this.props.dispatch(startSyncingOrganization(this.props.organization._id));
        });
      }
    };

    uploadNextChunk();
  }


  handleUploadWhole(selectedFile) {
    const formData = new FormData();
    formData.append('file', selectedFile);

    const onUploadProgress = (progressEvent) => {
      const progress = (progressEvent.loaded / progressEvent.total) * 50;
      this.setState({
        progress,
        status: `Uploading... ${progress}`,
      });
    };

    // when server response
    const onDownloadProgress = (progressEvent) => {
      const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
      this.setState({
        progress,
        status: `Downloading... ${progress}`,
      });
    }

    
    this.props.dispatch(requestUploadFile(formData, { onUploadProgress, onDownloadProgress }))
      .then(
        (data) => {
          console.log('data', data);
          this.props.dispatch(startSyncingOrganization(this.props.organization._id));
        },
      )
      .catch((error) => {
        this.setState({
          uploading: false,
          progress: 0,
          status: null,
          error: error?.data?.message || 'Error uploading',
        });
      });
  }

  handleFileChange(event) {
    const selectedFile = event.target.files[0];
    if (this.state.uploading) {
      return;
    }

    this.setState({ uploading: true, progress: 0, status: null, error: null }, () => {
      if (this.props.chunks) {
        this.handleUploadChunks(selectedFile);
      } else {
        this.handleUploadWhole(selectedFile);
      }
    });
  }


  render() {
    const { uploading, progress, status, error } = this.state;
    

    return (
      <div>
        <p><strong>You can upload organizaton data in <code>.csv</code> files.</strong></p> 
        <p>Please compress all data files in a <code>.zip</code> format and include a <code>manifest.json</code> file with all the objects and fields you want to use in TruVoice Automation.<br /> You can <a href="/assets/sample-data.zip" target="_blank">download a sample .zip file</a> and follow the templates.</p>


        <div style={{ display: progress >= 100 ? 'none' : '' }}>
          <input disabled={uploading} type="file" onChange={this.handleFileChange} />
        </div>
        
        {progress !== 0 && 
          <ProgressBar>
            <ProgressBar active bsStyle="success" striped now={progress} />
          </ProgressBar>
        }
        {progress > 0 && 
          <div className="alert alert-warning">please leave this window opened while the file being uploaded</div>
        }
        {status !== null && <p className="text-success">{status}</p>}
        {error !== null && <p className="text-danger">{error}</p>}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

ImportData.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({}).isRequired,
  chunks: PropTypes.bool,
};
ImportData.defaultProps = {
  chunks: false,
};
export default connect(mapStateToProps)(ImportData);
